<mat-form-field class="dict-regionals">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [required]="required"  [disabled]="disable"  (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
    <mat-option *ngIf="noneEntry" value="isNull">
      Brak
    </mat-option>
    <mat-option *ngFor="let item of items" [value]="item.uuid">
      {{ item.firstName }} {{item.lastName}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
